import React from 'react';
import { Col } from 'antd';
import FormRow from '../../../../common/formComponents/FormRow/FormRow';
import styles from '../ChessForm.module.scss';

const SubtitleRow = ({ subtitle, switchField }) => {
  return (
    <FormRow rowType='subtitle'>
      <Col span={switchField ? 10 : 24}>
        <p className={styles.subtitle}>{subtitle}</p>
      </Col>
      {switchField && <Col span={14}>{switchField}</Col>}
    </FormRow>
  );
};

export default SubtitleRow;
